import { memo } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useLocalStorage } from 'root/src/client/web/hooks/useLocalStorage';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
import { Checkbox } from 'root/src/client/v2/common/components/ui/checkbox';
import { Button } from 'root/src/client/v2/common/components/ui/button';
export const RedesignSubmissionPlatformModal = memo(({ onConfirm, onCancel }) => {
    const [showSubmissionModal, setShowSubmissionModal] = useLocalStorage('showSubmissionModal', true);
    return (<RedesignModalShell className="sm:max-w-md">
			<div className="flex w-full flex-col items-center gap-3 text-center">
				<div className="flex h-12 w-12 items-center justify-center rounded-full border border-solid border-neon-amber/30 bg-neon-amber/10">
					<InfoOutlinedIcon sx={{ fontSize: 24 }} className="text-neon-amber"/>
				</div>
				<h2 className="font-display text-xl font-bold text-foreground">Platform-specific dare</h2>
				<p className="text-sm text-muted-foreground">This dare is platform specific. Make sure you upload your video to the correct platform.</p>
			</div>

			<label htmlFor="sp-dismiss" className="flex cursor-pointer select-none items-center gap-2 text-xs text-muted-foreground">
				<Checkbox id="sp-dismiss" checked={!showSubmissionModal} onCheckedChange={value => setShowSubmissionModal(!value)}/>
				Don&apos;t show this again
			</label>

			<div className="flex w-full gap-2">
				<Button variant="secondary" onClick={onCancel} className="flex-1 rounded-lg text-sm">Cancel</Button>
				<Button variant="brand" onClick={onConfirm} className="flex-1 rounded-lg text-sm">I understand</Button>
			</div>
		</RedesignModalShell>);
});
// Redesign of the Redux-driven dare-submission confirm. Returns a promise that resolves true
// (continue) or false (cancel), matching the legacy `useSubmissionPlatformModal` contract.
export const useRedesignSubmissionPlatformModal = () => {
    const modal = useRedesignModal();
    return () => new Promise((resolve) => {
        modal.show(<RedesignSubmissionPlatformModal onCancel={() => { modal.hide(); resolve(false); }} onConfirm={() => { modal.hide(); resolve(true); }}/>, { closeable: false });
    });
};
